import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=bb8c619e&scoped=true&"
import script from "./Changelog.vue?vue&type=script&lang=ts&"
export * from "./Changelog.vue?vue&type=script&lang=ts&"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=bb8c619e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8c619e",
  null
  
)

export default component.exports